import { isPlatformBrowser } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID, Optional } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { CAPTCHA_CONFIG } from './captcha.config';
import { CaptchaConfig } from './captcha.interface';
import type { CaptchaAction } from './captcha.types';

@UntilDestroy({ className: 'CaptchaService' })
@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  constructor(
    @Optional() @Inject(CAPTCHA_CONFIG) private config: CaptchaConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
    private reCaptchaV3Service: ReCaptchaV3Service,
  ) {}

  getCaptchaV3Token(action: CaptchaAction): Promise<string | undefined> {
    if (!isPlatformBrowser(this.platformId)) {
      // Don't execute if running on the server
      return Promise.resolve(undefined);
    }
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    style.appendChild(
      document.createTextNode(`
      .grecaptcha-badge {
        display: none;
      }`),
    );

    head.appendChild(style);

    return this.reCaptchaV3Service.executeAsPromise(
      this.config.recaptchaV3PublicKey,
      action,
      { useGlobalDomain: true },
    );
  }
}
